import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=536e44fa&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536e44fa')) {
      api.createRecord('536e44fa', component.options)
    } else {
      api.reload('536e44fa', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=536e44fa&", function () {
      api.rerender('536e44fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/search-results/SearchResults.vue"
export default component.exports